export default [
  {
    path: 'makeComplaints',
    name: 'MakeComplaints',
    meta: {
      title: '星言星语'
    },
    component: () =>
      import(
        '../views/exerland/makeComplaints/list.vue'
      )
  },
  {
    path: 'makeComplaintsDetails/:id',
    name: 'MakeComplaintsDetails',
    meta: {
      title: '星言星语'
    },
    component: () =>
      import(
        '../views/exerland/makeComplaints/details.vue'
      )
  },
  {
    path: 'intelligentAssistant',
    name: 'IntelligentAssistant',
    meta: {
      title: '数智助理-任务提醒'
    },
    component: () => import('../views/exerland/makeComplaints/IntelligentAssistant.vue')
  },
  {
    path: 'makeComplaintsCreate',
    name: 'MakeComplaintsCreate',
    meta: {
      title: '星言星语'
    },
    component: () =>
      import(
        '../views/exerland/makeComplaints/create.vue'
      )
  }
]
